import {EDIT_TABLE_PAYLOAD, EMPTY_EDIT_TABLE_PAYLOAD} from "../Types/types";

export function editTablePayload(data: any) {
  return {
    type: EDIT_TABLE_PAYLOAD,
    payload: data
  }
}

export function emptyEditTablePayload()
{
  return {
    type: EMPTY_EDIT_TABLE_PAYLOAD,
    payload: null
  }
}